// AuthRedirectHandler.js - FIXED with duplicate prevention
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { msalInstance } from "../msalConfig";
import { getAuthApiToken } from "../api/tokenService";
import { getMe } from "../api/authApi";
import { useAuth } from "../context/AuthContext";

export default function AuthRedirectHandler() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const hasHandled = useRef(false); // Prevent duplicate handling

    useEffect(() => {
        const handleRedirect = async () => {
            // Prevent duplicate handling
            if (hasHandled.current) {
                console.log("🔄 Redirect already handled, skipping");
                return;
            }

            try {
                // Check if we just came back from logout
                const justLoggedOut = sessionStorage.getItem('justLoggedOut');
                if (justLoggedOut === 'true') {
                    const logoutTime = sessionStorage.getItem('logoutTime');
                    const timeSinceLogout = Date.now() - parseInt(logoutTime || '0');

                    if (timeSinceLogout < 10000) {
                        console.log("🚪 Recent logout detected, clearing session");
                        sessionStorage.removeItem('justLoggedOut');
                        sessionStorage.removeItem('logoutTime');

                        // Clear any lingering MSAL data
                        msalInstance.setActiveAccount(null);
                        await msalInstance.clearCache();

                        // Clear URL parameter
                        window.history.replaceState({}, document.title, window.location.pathname);
                        return;
                    }
                }

                // Handle the redirect response
                const response = await msalInstance.handleRedirectPromise();

                if (response && response.account) {
                    hasHandled.current = true;
                    console.log("Redirect login successful");

                    // Set active account
                    msalInstance.setActiveAccount(response.account);

                    // Get token for auth API
                    const token = await getAuthApiToken(response.account);

                    // Get user data
                    const user = await getMe();

                    // Store in context
                    login(user, response.idToken);

                    // Navigate after successful login (preserve the entry path)
                    navigate(window.location.pathname || "/");
                }
            } catch (err) {
                console.error("Redirect handling error:", err);
            }
        };

        handleRedirect();
    }, [login, navigate]);

    return null;
}